<template>
        <div class="warp">
        <breadcrumb :back="true" :crubList="[{name:'系统配置'},{name:'管理员配置',goback:true},{name:'管理员详情'}]" :title="'管理员详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="基础信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">姓名：</div>
                        <div class="content">{{detail.realName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号：</div>
                        <div class="content">{{detail.createUserName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">管理员类型：</div>
                        <div class="content">{{detail.administratorTypeName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="childMulti">
                        <div class="name">绑定角色：</div>
                        <ul>
                            <li v-for="(item,index) in detail.roleNames" :key="index">{{item}}</li>
                        </ul>
                    </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                        <div class="name">创建人：</div>
                        <div class="content">{{detail.createName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">创建时间：</div>
                        <div class="content">{{detail.createTime}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">更新人：</div>
                        <div class="content">{{detail.modifyName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                      <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{detail.updateTime}}</div>
                    </div>
                  </el-col>
                  
                </el-row>
              </el-card>
             
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{
                realName: void 0
            },
      ishide:false,
        }
    },
    methods:{
        
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosz.get('backstage/administrator/view/'+this.id)
          if (code == 200) {            
              this.detail = data;
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){        
        this.id=this.$route.params.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height: 100%;
  overflow: hidden;
}
.box{
    // margin-top: 20px;
    height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>